<!-- eslint-disable vue/no-mutating-props -->
<template>
  <modal
    :show="show"
    :on-close="onClose"
    @update:show="$emit('update:show', $event)"
  >
    <otello-modal-header
      :header-title="title"
      :header-content="message"
      :header-content-value="messageValue"
    >
      <slot />
    </otello-modal-header>
    <div class="flex justify-end items-center gap-2 p-8">
      <otello-button variant="clear" class="action-button" @click="onClose">
        {{ rejectText }}
      </otello-button>
      <otello-button
        color-scheme="alert"
        class="action-button"
        variant="smooth"
        @click.stop.prevent="onConfirm"
      >
        {{ confirmText }}
      </otello-button>
    </div>
  </modal>
</template>

<script>
import Modal from '../../Modal.vue';

export default {
  components: {
    Modal,
  },
  props: {
    show: Boolean,
    onClose: { type: Function, default: () => {} },
    onConfirm: { type: Function, default: () => {} },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    messageValue: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    rejectText: { type: String, default: '' },
  },
};
</script>
<style lang="scss" scoped>
.action-button {
  max-width: var(--space-giga);
}
</style>
